<template>
  <div>
    <vue-headful :title="title" />
    <div class="mx-4 my-2">
      <div class="card">
        <div class="card-content">
          <b-button type="is-primary is-outlined" icon-left="plus" @click="openAddMetricGraphModal">Add Graph</b-button>
        </div>
      </div>
    </div>
    <div class="m-4" v-if="terminal">
      <p v-if="graphs && graphs.length == 0">Add some graphs via the button above!</p>
      <div class="metric-graphs" v-else>
        <div class="box" v-for="graph in graphs" :key="graph.id">
          <metric-chart 
            :graph="graph" 
            :remote-id="terminal.id"
            :is-terminal="true"
            @remove="removeGraph"></metric-chart>
        </div>
      </div>
    </div>
  </div>
</template>
<script setup>
import { computed, getCurrentInstance } from 'vue';
import { useTerminalsStore } from '../terminals-store';
import { useAppSettingsStore } from '../../user/stores/appsettings-store';
import TerminalAddMetricGraphModal from '../components/TerminalAddMetricGraphModal.vue';
import MetricChart from '../../remotes/components/RemoteDetailMetricChartComponent.vue';

const app = getCurrentInstance();
const store = useTerminalsStore();
const appSettingsStore = useAppSettingsStore();
const terminal = computed(() => store.state.terminal);
const title = computed(() => `${terminal.value?.name} / Metrics`);
const graphs = computed(() => appSettingsStore.state.userGraphs);

const openAddMetricGraphModal = () => {
  app.proxy.$buefy.modal.open({
    hasModalCard: true,
    component: TerminalAddMetricGraphModal,
    trapFocus: true,
    width: 640
  });
}

const removeGraph = (graphId) => {
  app.proxy.$kya.event('terminals', 'metricGraphRemove', 'Remove Graph clicked.', { terminalId: terminal?.value?.id });
  appSettingsStore.commit('removeUserGraph', graphId);
  appSettingsStore.dispatch('updateSetting', { key: 'userGraphs', value: graphs?.value });
}

</script>
<style lang="scss">
@import '../../styles/mixins';

.metric-graphs {
  @include display-grid;
  grid-template-columns: 1fr 1fr;
  gap: 13px;
  flex-wrap: wrap;

  .box {
    padding: 12px;
    min-width: 400px;
    margin-bottom: 0px;
  }
}
</style>
